import React from "react"
import PropTypes from "prop-types"
import Select from 'react-select'
import axios from 'axios';

class VendorSelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props,
      vendors: [],
      isMounted: false
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.vendorSelected = this.vendorSelected.bind(this)
  }

  componentDidMount() {
    let { vendorId } = this.props
    if (vendorId) {
      this.getVendorFromId(vendorId)
    } else {
      this.getCollection()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.vendorId != this.props.vendorId && this.state.isMounted) {
      let selectOption = this.state.vendors.filter(option => option.value == this.props.vendorId)[0]
      this.props.onChange(this.props.vendorId, selectOption)
    }
  }

  handleInputChange(value) {
    if (value !== "") {
      this.getCollection(value)
    }
  }

  setOptions(response) {
    let options = []
    response.data.map(e => {
      options.push({ id: e.id, text: e.name, value: e.id })
    })
    this.setState({
      vendors: options,
      isMounted: true
    })
  }

  getVendorFromId(vendorId) {
    axios.get(`${process.env.REACT_APP_API_URL}/vendors/${vendorId}`)
    .then((response) => {
      let options = [{ id: response.data.id, text: response.data.name, value: response.data.id }]
      this.setState({
        vendors: options,
        isMounted: true
      })
    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      // always executed
    });
  }

  getCollection(query) {
    let params = {
      // range: '[0, 15]',
      sort: ["id","ASC"],
      filter: {is_active: true}
    }
    if (query) {
      params.filter.name = query
    }

    axios.get(`${process.env.REACT_APP_API_URL}/vendors`, {
      params: params
    })
    .then((response) => {
      this.setOptions(response)
    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      // always executed
    });
  }

  vendorSelected(e) {
    let value = e.value
    if (value !== this.props.vendorId && this.state.isMounted) {
      this.props.onChange(value, e)
    }
  }

  render() {
    return (
      <React.Fragment>
        <Select
          className="select2-style"
          onChange={this.vendorSelected}
          onInputChange={this.handleInputChange}
          getOptionLabel={option =>
            `${option.text}`
          }
          value={this.state.vendors.filter(option => option.value === this.props.vendorId)}
          getOptionValue={option => `${option.id}`}
          options={this.state.vendors}
          isDisabled={this.props.disabled}
          placeholder={'ค้นหา...'}
        />
      </React.Fragment>
    );
  }
}

VendorSelect.propTypes = {
  vendorId: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

export default VendorSelect
